import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "react-bootstrap";
import Tour from "reactour";

// {
/* <Reactour
  lastStepNextButton={
    <TrackedButton
      className="tour__btn--finish"
      variant="primary"
      onClick={this.onRequestClose}
      action="tourFinishClick"
      label={this.props.id}
    >
      Finish
    </TrackedButton>
  }
  steps={this.props.steps}
  isOpen={run}
  onRequestClose={this.onRequestClose}
  update={this.props.hashes[this.props.id] || ""}
/>; */
// }

type Props = {};

// transaction-manager-filter-fieldName
// transaction-manager-missing-transactions
// transaction-manager-pagination
// transaction-manager-transactions
// btn--report-bad-job
// btn--download-data
// transaction-manager-missing-transactions

const steps = [
  {
    selector: ".transation-manager-select-document-id",
    content:
      "Select a document. DocuClipper displays the transactions and summary information of one document at a time.",
  },
  {
    selector: ".tx-manager-account-selector",
    content:
      "Select the account e.g. 'checking'. A blue badge indicates the account is reconciled.",
  },
  {
    selector: ".tx-manager-period-selector",
    content:
      "Select the period, e.g. '2023-01-01 to 2023-01-31'. A blue badge indicates the period is reconciled.",
  },
  {
    selector: ".summary-table-dates-balances",
    content:
      "Summary information like totals, number of credits and debits, etc. Edit start/end dates and start/end balances for a given period.",
  },
  {
    selector: ".transaction-manager-pagination",
    content:
      "Browse the transactions. DocuClipper displays one page of transactions at a time. Only pages with transactions are shown.",
  },
  {
    selector: ".tx-manager-column-included",
    content: "Include or exclude each transaction by clicking the button.",
  },
  {
    selector: ".tx-manager-column-date",
    content:
      "Correct the values of the transactions by clicking on the cell and entering a new value.",
  },
  {
    selector: ".transaction-manager-missing-transactions",
    content: 'Click on "Add Transaction" to add any missing transactions.',
  },

  {
    selector: ".tx-manager-column-bulk-selection",
    content: "Select multiple transactions",
  },
  {
    selector: ".bulk-edit-buttons",
    content: "Make changes to the selected transations in bulk.",
  },
  {
    selector: ".assign-to-account-btn",
    content: "Assign selected transactions to a different account or period.",
  },
  {
    selector: ".btn--report-bad-job",
    content: "Get help and report issues to the support team",
  },

  {
    selector: ".btn--download-data",
    content:
      "Click here to download the data. DocuClipper supported formats include Excel, QuickBooks, Xero and other third party applications.",
  },

  // ...
];

export const TransactionManagerTour: React.FC<Props> = ({}) => {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Button onClick={() => setOpen(true)} variant="secondary">
        <FontAwesomeIcon icon="play" />
        <span className="ml-1">Tutorial</span>
      </Button>
      <Tour steps={steps} isOpen={open} onRequestClose={() => setOpen(false)} />
    </>
  );
};
export default TransactionManagerTour;
